
export default function initAccordion() {
  const selectors = {
    accordionBtn: '[data-accordion-btn]',
    panel: '[data-accordion-panel]',
  }

  const accordionBtn: NodeListOf<HTMLButtonElement> = document.querySelectorAll(selectors.accordionBtn);
  const panel: NodeListOf<HTMLDivElement> = document.querySelectorAll(selectors.panel);
  let i;

  if (accordionBtn.length === 0) return;

  const getAccordionItemPanelHeight = () => {
    panel.forEach((element: HTMLDivElement) => {
      element.setAttribute('data-height', String(element.scrollHeight));
      element.classList.add('invisible');
      element.classList.add('max-h-0');
      element.setAttribute('aria-expanded', 'false');
      element.closest('li').querySelector('svg').classList.remove('rotate-180');
    });
  }

  const loadAccordion = () => {
    getAccordionItemPanelHeight();

    for (i = 0; i < accordionBtn.length; i++) {
      accordionBtn[i].addEventListener("click", (e: any) => {
        const target = (e.target as HTMLButtonElement);
        const caret = target.querySelector('svg');
        const currentPanel = (target.nextElementSibling as HTMLDivElement);
        const currentPanelState = currentPanel.getAttribute('aria-expanded');

        panel.forEach((element: HTMLDivElement) => {
          const carets = element.parentElement.parentElement.querySelectorAll('svg');

          element.setAttribute('aria-expanded', 'false');
          element.classList.add('invisible');
          element.classList.add('max-h-0');

          carets.forEach((caret: any) => {
            caret.classList.remove('rotate-180');
          });

          if (element.previousElementSibling.classList.contains('active')) {
            element.previousElementSibling.classList.remove("active");
            element.style.height = '';
          }
        });

        if (currentPanelState === 'false'){
          currentPanel.setAttribute('aria-expanded', 'true');
          currentPanel.classList.remove('invisible');
          currentPanel.classList.remove('max-h-0');
          currentPanel.previousElementSibling.classList.add('active');
          currentPanel.style.height = currentPanel.getAttribute('data-height') + 'px';
          caret.classList.add('rotate-180');
        } else {
          currentPanel.setAttribute('aria-expanded', 'false');
          currentPanel.classList.add('invisible');
          currentPanel.classList.add('max-h-0');
          currentPanel.previousElementSibling.classList.remove('active');
          currentPanel.style.height = '';
          caret.classList.remove('rotate-180');
        }
      });
    }

    panel.forEach((element) => {
      element.classList.remove('opacity-0');
    });
    window.removeEventListener('load', loadAccordion);
  }

  window.addEventListener('load', loadAccordion);
  window.addEventListener('resize', getAccordionItemPanelHeight);
}

initAccordion();
